import { s as setGlobalConfig } from './DSRadioInput.vue_vue_type_script_setup_true_lang-BYPjfzz_.js';
export { _ as DSButton, D as DSCalendar, a as DSCalendarInput, b as DSCheckbox, c as DSCheckboxInput, d as DSDateCalendarInput, e as DSIcon, f as DSListboxInput, g as DSNumberInput, h as DSPopup, i as DSRadioInput, j as DSTooltip } from './DSRadioInput.vue_vue_type_script_setup_true_lang-BYPjfzz_.js';
import { c as components } from './index-IaTSZESL.js';
export { D as DSAccordion, _ as DSAlert, a as DSAsyncButton, b as DSAvatar, d as DSAvatarList, e as DSBackdrop, f as DSBreadcrumbs, g as DSCard, h as DSChip, i as DSClipboard, j as DSCollapse, k as DSComboboxInput, E as DSComponentPropsValueAdapter, l as DSCssVariables, m as DSDataPager, n as DSDataPagerSummary, T as DSDataTable, o as DSDateRangeInput, p as DSDebugInfo, q as DSDropdown, r as DSErrorBoundary, s as DSFakeProgressBar, t as DSGroupedDataTemplate, u as DSImage, v as DSLineClamp, w as DSLoadingWrapper, x as DSModal, y as DSModalsContainer, z as DSNotifier, A as DSOffcanvas, B as DSPersonComboboxInput, C as DSProgressBar, F as DSProvider, H as DSRadio, G as DSRating, I as DSScrollspy, J as DSSpinner, L as DSStacked, M as DSStepper, K as DSSwitch, N as DSTabBar, O as DSTable, P as DSTableCell, Q as DSTableHeader, R as DSTableRow, S as DSThemeProvider } from './index-IaTSZESL.js';

function install(app, options = {}) {
  setGlobalConfig(options);
  for (const key in components) {
    if (components[key][Symbol.toStringTag] === "Module") {
      const namespace = key;
      const subcomponents = components[key].default;
      for (const cmp in subcomponents)
        app.component(`${namespace}.${cmp}`, subcomponents[cmp]);
    } else {
      app.component(key, components[key]);
    }
  }
}
const index = { install };

export { index as default };
//# sourceMappingURL=index.js.map
